import { gql } from '@apollo/client';

export const postEsClienteDemandaIFE = gql`
mutation EsClienteDemandaIFERQ{
    EsClienteDemandaIFERQ(input: $input)  
        @rest(type: "EsClienteDemandaIFERS", path: "/api/gateway/formulariosComercios/presolicitudife",  method: "post"){
            nroCuentas    
            resultado
            mensaje
        }
}
`